document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initFaq();
  initGalerias();
  initProductos();
  initContadorColeccionYBusqueda();
  initCierreProducto();
});

/* Botón "ELEGIR MI COLLAR" del bloque de cierre: no añade nada al carrito,
   solo desplaza hasta el configurador (acabado + modalidad) de la ficha
   principal. El desplazamiento respeta la altura de la cabecera fija
   mediante scroll-margin-top en #mt-configurador (ver mt-styles.css). */
function initCierreProducto() {
  document.querySelectorAll('[data-mt-ir-a-configurador]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var destino = document.getElementById('mt-configurador');
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

/* El Pack de 2 se oculta en Liquid en /collections/* y /search (sigue siendo
   comprable desde la ficha principal, ver mt-producto.liquid), pero el
   contador de "N productos" lo calcula Shopify ANTES de ese filtro, así que
   sigue contando el pack. Aquí se corrige con el número real de tarjetas
   visibles tras cargar la página. */
function initContadorColeccionYBusqueda() {
  var grid = document.getElementById('product-grid');
  if (!grid) return;
  var numTarjetas = grid.querySelectorAll('.grid__item').length;
  var texto = numTarjetas === 1 ? '1 producto' : numTarjetas + ' productos';
  if (numTarjetas === 0) texto = 'Sin resultados';
  document.querySelectorAll('#ProductCount, #ProductCountDesktop, .mobile-facets__count').forEach(function (el) {
    el.textContent = texto;
  });
}

/* ---------- Reveals al hacer scroll ---------- */
function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-i', i % 8);
    io.observe(el);
  });
}

/* ---------- FAQ acordeón ---------- */
function initFaq() {
  document.querySelectorAll('.mt-faq').forEach(function (faq) {
    faq.querySelectorAll('.mt-faq__item').forEach(function (item) {
      var boton = item.querySelector('.mt-faq__pregunta');
      var respuesta = item.querySelector('.mt-faq__respuesta');
      if (!boton || !respuesta) return;
      boton.setAttribute('aria-expanded', 'false');
      boton.addEventListener('click', function () {
        var abierta = item.classList.contains('mt-activa');
        faq.querySelectorAll('.mt-faq__item.mt-activa').forEach(function (otro) {
          if (otro !== item) {
            otro.classList.remove('mt-activa');
            otro.querySelector('.mt-faq__pregunta').setAttribute('aria-expanded', 'false');
            otro.querySelector('.mt-faq__respuesta').style.maxHeight = null;
          }
        });
        if (abierta) {
          item.classList.remove('mt-activa');
          boton.setAttribute('aria-expanded', 'false');
          respuesta.style.maxHeight = null;
        } else {
          item.classList.add('mt-activa');
          boton.setAttribute('aria-expanded', 'true');
          respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        }
      });
    });
  });
}

/* ---------- Galería simple (miniaturas -> imagen principal) ---------- */
/* Usada por bandas/secciones sueltas. La galería del producto tiene su propio control en initProductos. */
function initGalerias() {
  document.querySelectorAll('[data-mt-galeria-simple]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        minis.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
        principal.src = mini.dataset.mtSrc || mini.querySelector('img').src;
      });
    });
  });
}

/* ---------- Página de producto ---------- */
function initProductos() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
    new ProductoCruzDeFe(raiz);
  });
}

function ProductoCruzDeFe(raiz) {
  this.raiz = raiz;
  this.seccion = raiz.closest('[data-mt-seccion-producto]') || raiz;

  this.variantes = {
    dorado: raiz.dataset.variantDorado,
    plateado: raiz.dataset.variantPlateado
  };
  /* El Pack de 2 es un producto real independiente (3 variantes, una por combinación
     de acabados) para que cada compra del pack sea una única línea de carrito
     indivisible — nunca dos líneas sueltas de la variante individual. */
  this.variantesPack = {
    doradoDorado: raiz.dataset.variantPackDd,
    doradoPlateado: raiz.dataset.variantPackDp,
    plateadoPlateado: raiz.dataset.variantPackPp
  };
  this.precios = {
    unidad: raiz.dataset.precioUnidad,
    unidadAntes: raiz.dataset.precioUnidadAntes,
    pack: raiz.dataset.precioPack,
    packAntes: raiz.dataset.precioPackAntes,
    ahorro: raiz.dataset.ahorroPack,
    envioUnidad: raiz.dataset.envioUnidad
  };
  this.textosBoton = {
    unidad: raiz.dataset.textoBotonUnidad,
    pack: raiz.dataset.textoBotonPack,
    incompleto: raiz.dataset.textoBotonIncompleto
  };
  this.microcopy = {
    unidad: raiz.dataset.microcopyUnidad,
    pack: raiz.dataset.microcopyPack
  };

  this.estado = { modalidad: 'unidad', acabado: 'dorado', collar2: '' };

  this.cachearElementos();
  this.bindEventos();
  this.pintar();
  this.initGaleria();
  this.initBarraFija();
}

ProductoCruzDeFe.prototype.cachearElementos = function () {
  var r = this.raiz;
  this.el = {
    pillsAcabado: r.querySelectorAll('[data-mt-acabado]'),
    acabadoActualTexto: r.querySelector('[data-mt-acabado-actual]'),
    etiquetaAcabado: r.querySelector('[data-mt-etiqueta-acabado]'),
    bloqueAcabado: r.querySelector('[data-mt-bloque-acabado]'),
    modalidadBotones: r.querySelectorAll('[data-mt-modalidad]'),
    fraseEmocional: r.querySelector('[data-mt-frase-pack]'),
    packSelectores: r.querySelector('[data-mt-pack-selectores]'),
    pillsCollar2: r.querySelectorAll('[data-mt-collar2]'),
    collar2ActualTexto: r.querySelector('[data-mt-collar2-actual]'),
    precioActual: r.querySelector('[data-mt-precio-actual]'),
    precioAntes: r.querySelector('[data-mt-precio-antes]'),
    envioNota: r.querySelector('[data-mt-envio-nota]'),
    form: r.querySelector('[data-mt-form]'),
    submitBoton: r.querySelector('[data-mt-submit]'),
    submitTexto: r.querySelector('[data-mt-submit-texto]'),
    microcopy: r.querySelector('[data-mt-microcopy]'),
    error: r.querySelector('[data-mt-error]'),
    ok: r.querySelector('[data-mt-ok]')
  };
  this.baseEtiquetaAcabado = this.el.etiquetaAcabado ? this.el.etiquetaAcabado.textContent : '';
  this.placeholderAcabado = this.el.collar2ActualTexto ? this.el.collar2ActualTexto.textContent : '';
};

ProductoCruzDeFe.prototype.bindEventos = function () {
  var self = this;

  this.el.pillsAcabado.forEach(function (pill) {
    pill.addEventListener('click', function () {
      self.estado.acabado = pill.dataset.mtAcabado;
      self.actualizarGaleriaPorAcabado();
      self.pintar();
    });
  });

  this.el.modalidadBotones.forEach(function (btn) {
    btn.addEventListener('click', function () {
      self.estado.modalidad = btn.dataset.mtModalidad;
      if (self.estado.modalidad === 'unidad') {
        self.ocultarError();
      }
      self.pintar();
    });
  });

  this.el.pillsCollar2.forEach(function (pill) {
    pill.addEventListener('click', function () {
      self.estado.collar2 = pill.dataset.mtCollar2;
      self.ocultarError();
      self.pintar();
    });
  });

  if (this.el.form) {
    this.el.form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      self.intentarAnadirAlCarrito();
    });
  }
};

ProductoCruzDeFe.prototype.pintar = function () {
  var esPack = this.estado.modalidad === 'pack';

  this.el.modalidadBotones.forEach(function (btn) {
    var activa = btn.dataset.mtModalidad === (esPack ? 'pack' : 'unidad');
    btn.classList.toggle('mt-activa', activa);
    btn.setAttribute('aria-checked', activa ? 'true' : 'false');
  });

  this.el.pillsAcabado.forEach(function (pill) {
    var activa = pill.dataset.mtAcabado === this.estado.acabado;
    pill.classList.toggle('mt-activa', activa);
    pill.setAttribute('aria-checked', activa ? 'true' : 'false');
  }, this);

  if (this.el.acabadoActualTexto) {
    this.el.acabadoActualTexto.textContent = this.textoAcabado(this.estado.acabado);
  }
  if (this.el.etiquetaAcabado) {
    this.el.etiquetaAcabado.textContent = esPack ? 'Collar 1' : this.baseEtiquetaAcabado;
  }

  this.el.pillsCollar2.forEach(function (pill) {
    var activa = pill.dataset.mtCollar2 === this.estado.collar2;
    pill.classList.toggle('mt-activa', activa);
    pill.setAttribute('aria-checked', activa ? 'true' : 'false');
  }, this);
  if (this.el.collar2ActualTexto) {
    this.el.collar2ActualTexto.textContent = this.estado.collar2 ? this.textoAcabado(this.estado.collar2) : this.placeholderAcabado;
  }

  if (this.el.fraseEmocional) this.el.fraseEmocional.hidden = !esPack;
  if (this.el.packSelectores) this.el.packSelectores.hidden = !esPack;

  if (this.el.precioActual) {
    this.el.precioActual.textContent = esPack ? this.precios.pack : this.precios.unidad;
  }
  if (this.el.precioAntes) {
    this.el.precioAntes.textContent = esPack ? this.precios.packAntes : this.precios.unidadAntes;
    this.el.precioAntes.style.display = esPack ? (this.precios.packAntes ? '' : 'none') : (this.precios.unidadAntes ? '' : 'none');
  }
  if (this.el.envioNota) {
    this.el.envioNota.textContent = esPack ? 'Envío gratuito' : ('Envío: ' + this.precios.envioUnidad);
  }
  if (this.el.microcopy) {
    this.el.microcopy.textContent = esPack ? this.microcopy.pack : this.microcopy.unidad;
  }

  this.actualizarBotonCompra();
  this.actualizarBarraFija();
};

/* Estado del botón de compra: qué dice, si lleva precio y si debe estar
   desactivado. Un único cálculo alimenta el botón principal y el CTA flotante,
   para que nunca puedan mostrar información distinta entre sí. */
ProductoCruzDeFe.prototype.calcularEstadoBoton = function () {
  var esPack = this.estado.modalidad === 'pack';
  if (!esPack) {
    return { texto: this.textosBoton.unidad, precio: this.precios.unidad, deshabilitado: false };
  }
  if (!this.estado.collar2) {
    return { texto: this.textosBoton.incompleto, precio: null, deshabilitado: true };
  }
  return { texto: this.textosBoton.pack, precio: this.precios.pack, deshabilitado: false };
};

ProductoCruzDeFe.prototype.actualizarBotonCompra = function () {
  var estado = this.calcularEstadoBoton();
  var texto = estado.precio ? (estado.texto + ' · ' + estado.precio) : estado.texto;

  if (this.el.submitTexto) this.el.submitTexto.textContent = texto;
  if (this.el.submitBoton) {
    this.el.submitBoton.disabled = estado.deshabilitado;
    this.el.submitBoton.setAttribute('aria-disabled', estado.deshabilitado ? 'true' : 'false');
  }

  if (this.barraBotonTexto) this.barraBotonTexto.textContent = texto;
  var barraBoton = this.barra ? this.barra.querySelector('[data-mt-barra-boton]') : null;
  if (barraBoton) {
    barraBoton.disabled = estado.deshabilitado;
    barraBoton.setAttribute('aria-disabled', estado.deshabilitado ? 'true' : 'false');
  }
};

ProductoCruzDeFe.prototype.textoAcabado = function (acabado) {
  return acabado === 'plateado' ? 'Plateado' : 'Dorado';
};

ProductoCruzDeFe.prototype.ocultarError = function () {
  if (this.el.error) this.el.error.classList.remove('mt-visible-flex');
};

ProductoCruzDeFe.prototype.mostrarError = function (msg) {
  if (!this.el.error) return;
  this.el.error.textContent = msg;
  this.el.error.classList.add('mt-visible-flex');
};

/* ---------- Galería: la imagen principal sigue al acabado elegido ---------- */
ProductoCruzDeFe.prototype.initGaleria = function () {
  var self = this;
  this.galeria = this.seccion.querySelector('[data-mt-galeria]');
  if (!this.galeria) return;
  this.slots = this.galeria.querySelectorAll('[data-mt-slot]');
  this.minis = this.galeria.querySelectorAll('[data-mt-mini]');

  this.minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      self.activarSlot(parseInt(mini.dataset.mtMini, 10));
    });
  });

  this.actualizarGaleriaPorAcabado();
};

ProductoCruzDeFe.prototype.activarSlot = function (indice) {
  if (!this.slots) return;
  this.slots.forEach(function (img) {
    img.classList.toggle('mt-activa', parseInt(img.dataset.mtSlot, 10) === indice);
  });
  this.minis.forEach(function (mini) {
    mini.classList.toggle('mt-activa', parseInt(mini.dataset.mtMini, 10) === indice);
  });
};

ProductoCruzDeFe.prototype.actualizarGaleriaPorAcabado = function () {
  if (!this.slots || !this.slots.length) return;
  var slot0 = this.galeria.querySelector('[data-mt-slot="0"]');
  if (slot0) {
    var src = this.estado.acabado === 'plateado' ? slot0.dataset.srcPlateado : slot0.dataset.srcDorado;
    if (src) slot0.src = src;
  }
  var mini0 = this.galeria.querySelector('[data-mt-mini="0"] img');
  if (mini0) {
    var srcMini = this.estado.acabado === 'plateado' ? mini0.dataset.srcPlateado : mini0.dataset.srcDorado;
    if (srcMini) mini0.src = srcMini;
  }
  this.activarSlot(0);
};

/* ---------- Barra fija móvil ---------- */
ProductoCruzDeFe.prototype.initBarraFija = function () {
  var self = this;
  this.barra = this.seccion.querySelector('[data-mt-barra-fija]') || document.querySelector('[data-mt-barra-fija]');
  if (!this.barra) return;

  this.barraAcabado = this.barra.querySelector('[data-mt-barra-acabado]');
  this.barraPrecio = this.barra.querySelector('[data-mt-barra-precio]');
  this.barraBotonTexto = this.barra.querySelector('[data-mt-barra-boton-texto]');
  var barraBoton = this.barra.querySelector('[data-mt-barra-boton]');
  if (barraBoton) {
    barraBoton.addEventListener('click', function () { self.intentarAnadirAlCarrito(); });
  }
  this.actualizarBotonCompra();

  var referencia = this.el.form || this.raiz;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        self.barra.classList.toggle('mt-visible-flex', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(referencia);
  }
};

ProductoCruzDeFe.prototype.actualizarBarraFija = function () {
  if (!this.barra) return;
  var esPack = this.estado.modalidad === 'pack';
  if (this.barraAcabado) {
    this.barraAcabado.textContent = esPack ? 'Pack de 2' : this.textoAcabado(this.estado.acabado);
  }
  if (this.barraPrecio) {
    this.barraPrecio.textContent = esPack ? this.precios.pack : this.precios.unidad;
  }
};

/* ---------- Validación + añadir al carrito (sin recargar la página) ---------- */
ProductoCruzDeFe.prototype.variantePackPara = function (a, b) {
  if (a === 'dorado' && b === 'dorado') return this.variantesPack.doradoDorado;
  if (a === 'plateado' && b === 'plateado') return this.variantesPack.plateadoPlateado;
  return this.variantesPack.doradoPlateado;
};

ProductoCruzDeFe.prototype.intentarAnadirAlCarrito = function () {
  this.ocultarError();
  var esPack = this.estado.modalidad === 'pack';

  if (esPack) {
    if (!this.estado.collar2) {
      this.mostrarError('Elige el acabado del segundo collar para continuar.');
      return;
    }
    var idVariantePack = this.variantePackPara(this.estado.acabado, this.estado.collar2);
    this.enviarAlCarrito([
      {
        id: idVariantePack,
        quantity: 1,
        properties: {
          'Collar 1': this.textoAcabado(this.estado.acabado),
          'Collar 2': this.textoAcabado(this.estado.collar2),
          'Modalidad': 'Pack de 2',
          'Regalo': 'Uno para ti y otro para regalar'
        }
      }
    ]);
  } else {
    this.enviarAlCarrito([
      { id: this.variantes[this.estado.acabado], quantity: 1, properties: { 'Modalidad': '1 unidad' } }
    ]);
  }
};

ProductoCruzDeFe.prototype.enviarAlCarrito = function (items) {
  var self = this;
  var cartDrawer = document.querySelector('cart-drawer');
  var botones = [this.el.submitBoton, this.barra ? this.barra.querySelector('[data-mt-barra-boton]') : null].filter(Boolean);

  botones.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.disabled = true; });
  if (this.el.submitTexto) this.el.submitTexto.textContent = 'Añadiendo…';
  if (this.barraBotonTexto) this.barraBotonTexto.textContent = 'Añadiendo…';

  var sections = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
    ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
    : 'cart-drawer,cart-icon-bubble';

  var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

  fetch(addUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        self.mostrarError(data.description || data.message || 'No se ha podido añadir al carrito. Inténtalo de nuevo.');
        return;
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        window.location.href = window.Shopify && window.routes ? window.routes.cart_url : '/cart';
      }
      if (self.el.ok) {
        self.el.ok.classList.add('mt-visible-flex');
        setTimeout(function () { self.el.ok.classList.remove('mt-visible-flex'); }, 4000);
      }
    })
    .catch(function () {
      self.mostrarError('No hay conexión con la tienda ahora mismo. Inténtalo de nuevo en unos segundos.');
    })
    .finally(function () {
      botones.forEach(function (b) { b.removeAttribute('aria-disabled'); b.disabled = false; });
      self.actualizarBotonCompra();
    });
};
